export const ensureHttpPrefix = (url: string) => {
  if (!url.startsWith('http') || !url.startsWith('https')) {
    return `https://${url}`;
  }
  return url;
};
